import * as actionTypes from "../../constants/actionTypes";
import {
  getAccount,
  getBalance,
  getChainId,
  hexToNumber,
} from "../../common/BPADBlockStakeContract";

export const setLoading = (loading) => ({
  type: actionTypes.SET_LOADING,
  payload: {
    loading,
  },
});

export const setHasMetamask = (hasMetamask) => ({
  type: actionTypes.SET_HAS_METAMASK,
  payload: { hasMetamask },
});

export const setAccountDetails = (account, signature, balance) => ({
  type: actionTypes.SET_ACCOUNT_DETAILS,
  payload: {
    account,
    signature,
    balance,
  },
});

export const setError = (
  error,
  { errorTitle, errorMsg, errorBtnLabel, errorCallback = null }
) => ({
  type: actionTypes.SET_ERROR,
  payload: {
    error,
    errorMsg,
    errorTitle,
    errorBtnLabel,
    errorCallback,
  },
});

export const setChainId = (currentChainId) => ({
  type: actionTypes.SET_CHAIN_ID,
  payload: { currentChainId },
});

export const setEtherCurPrice = (etherCurPrice) => ({
  type: actionTypes.SET_ETHER_CUR_AMOUNT,
  payload: { etherCurPrice },
});

export const showWarning = (message) => ({
  type: actionTypes.SHOW_WARNING,
  payload: { message },
});

export const hideWarning = () => ({
  type: actionTypes.HIDE_WARNING,
  payload: {},
});

export const updateAccountDetailsOnChainChange = (chainId) => {
  return async (dispatch, getState) => {
    const isLogin = getState().login.isLogin;
    dispatch(setChainId(hexToNumber(chainId)));
    if (!isLogin) return;
    try {
      const acc = await getAccount();
      const balance = await getBalance(acc);
      const sign = getState().login.signature;
      dispatch(setAccountDetails(acc, sign, balance));
    } catch (error) { }
  };
};

export const updateChainId = () => {
  return async (dispatch) => {
    try {
      const chainId = await getChainId();
      dispatch(setChainId(chainId));
    } catch (error) { }
  };
};

export const showWalletModal = () => ({
  type: actionTypes.SHOW_WALLET_MODAL,
  payload: {},
});

export const hideWalletModal = () => ({
  type: actionTypes.HIDE_WALLET_MODAL,
  payload: {},
});

export const toggleWalletModal = () => ({
  type: actionTypes.TOGGLE_WALLET_MODAL,
  payload: {},
});

export const setApproved = (isApproved) => ({
  type: actionTypes.SET_APPROVED,
  payload: {
    isApproved: isApproved,
  },
});

export const setRealTimeValue = (changes) => ({
  type: actionTypes.SET_REALTIME_VALUES,
  payload: changes,
});

export const setWeb3Instance = (web3Instance) => ({
  type: actionTypes.SET_WEB3,
  payload: { web3Instance },
});

export const setNetwork = (network) => ({
  type: actionTypes.SET_NETWORK,
  payload: { network },
});

export const setNetworkIdFromUrl = (networkId) => ({
  type: actionTypes.SET_NETWORKID_FROM_URL,
  payload: networkId,
});

export const setCorePoolAddress = (corePoolAddress) => ({
  type: actionTypes.SET_CORE_POOL_ADDRESS,
  payload: corePoolAddress,
});

export const setCorePool = (corePool) => ({
  type: actionTypes.SET_CORE_POOL,
  payload: corePool,
});

export const setPoolAddresses = (
  poolFactoryAddress,
  rewardAddress,
  poolTokenAddress
) => ({
  type: actionTypes.SET_POOL_ADDRESSES,
  payload: { poolFactoryAddress, rewardAddress, poolTokenAddress },
});

export const setPoolContracts = (
  poolFactoryContract,
  rewardContract,
  poolTokenContract
) => ({
  type: actionTypes.SET_POOL_CONTRACTS,
  payload: { poolFactoryContract, rewardContract, poolTokenContract },
});

export const setTknSymbol = (
  rewardTknSymbol,
  poolTknSymbol
) => ({
  type: actionTypes.SET_TOKEN_SYMBOL,
  payload: { rewardTknSymbol, poolTknSymbol }
})

export const setProjectNamePoolName = (projectNamePoolName) => ({
  type: actionTypes.SET_DATA_FROM_POOL,
  payload: projectNamePoolName,
});

export const setRewardDecimalPoolTokenDecimal = (
  rewardDecimal,
  poolTokenDecimal
) => ({
  type: actionTypes.SET_REWARD_DECIMAL_POOL_TOKEN_DECIMAL,
  payload: { rewardDecimal, poolTokenDecimal },
});

export const setPoolDetailsFromFactory = (
  startBlock,
  currentBlockNO,
  endBlock,
  rewardTokenPerBlock
) => ({
  type: actionTypes.SET_POOL_DETAILS_FROM_FACTORY,
  payload: { startBlock, currentBlockNO, endBlock, rewardTokenPerBlock }
})

export const setFirstLoadData = (
  APY,
  balanceOfTvl,
  totalStakevalue,
  totalStake,
  reward
) => ({
  type: actionTypes.SET_FIRST_LOAD_DATA,
  payload: {
    APY,
    balanceOfTvl,
    totalStakevalue,
    totalStake,
    reward
  }
})

export const setSecondLoadData = (
  tokenBalance,
  Eligibleunstake,
  RewardDiff,
  rewardDistributed,
  rewardBalanceOf,
) => ({
  type: actionTypes.SET_SECOND_LOAD_DATA,
  payload: {
    tokenBalance,
    Eligibleunstake,
    RewardDiff,
    rewardDistributed,
    rewardBalanceOf,
  }
})

export const setActionBasedData = (
  APY,
  EligibleunStake,
  RewardDiff,
  balanceOfTvl,
  reward,
  rewardBalanceOf,
  rewardDistributed,
  tokenBalance,
  totalStake,
  totalStakevalue
) => ({
  type: actionTypes.SET_ACTION_BASED_DATA,
  payload: {
    APY,
    EligibleunStake,
    RewardDiff,
    balanceOfTvl,
    reward,
    rewardBalanceOf,
    rewardDistributed,
    tokenBalance,
    totalStake,
    totalStakevalue
  }
})
